export default __webpack_public_path__ + "static/media/exitFullscreen.f276d8f9.webp";